import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgGroup = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8 1.333A6.67 6.67 0 0 0 1.333 8 6.67 6.67 0 0 0 8 14.667 6.67 6.67 0 0 0 14.667 8 6.67 6.67 0 0 0 8 1.333zM5.333 11.667a1.667 1.667 0 1 1 .002-3.335 1.667 1.667 0 0 1-.002 3.335zm1-6.334a1.667 1.667 0 1 1 3.335.002 1.667 1.667 0 0 1-3.335-.002zm4.334 6.334a1.667 1.667 0 1 1 0-3.335 1.667 1.667 0 0 1 0 3.335z",
		fillRule: "nonzero"
	})
});
export default SvgGroup;
